export default __webpack_public_path__ + "static/11012-de8a04c5f2d54d7a12eceedbfd78c4f8.jpg";